<template>
  <v-dialog v-model="isDialogOpenCreate" max-width="720" persistent>
    <v-card rounded="xl" elevation="8">
      <!-- HEADER -->
      <v-card-title class="d-flex align-center justify-space-between px-6 py-4">
        <div>
          <div class="text-h6 font-weight-bold">
            Tambah Data Kertas Kerja Budget
          </div>

          <div class="text-caption text-medium-emphasis">
            Lengkapi informasi akun dengan benar
          </div>
        </div>

        <v-btn
          icon
          variant="text"
          size="small"
          @click="isDialogOpenCreate = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <!-- BODY -->
      <v-card-text class="pa-6">
        <v-form ref="formCreate" v-model="isFormValidCreate">
          <v-row>
            <!-- Nama -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="name"
                label="Nama"
                placeholder="Masukkan Nama"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-code-tags"
                :rules="rules.required"
              />
            </v-col>

            <!-- Account -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model="account"
                label="Account"
                placeholder="Masukkan Account"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-code-tags"
                :rules="rules.required"
              />
            </v-col>

            <!-- TYPE ACCOUNT -->
            <v-col cols="12" md="6">
              <v-select
                v-model="part"
                :items="listPart"
                label="Bagian"
                placeholder="Pilih Bagian"
                outlined
                dense
                prepend-inner-icon="mdi-shape-outline"
                :rules="rules.required"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />

      <!-- FOOTER -->
      <v-card-actions class="px-6 py-4">
        <v-spacer />

        <v-btn
          variant="outlined"
          color="secondary"
          @click="isDialogOpenCreate = false"
        >
          Cancel
        </v-btn>

        <v-btn
          color="primary"
          variant="flat"
          :disabled="!isFormValidCreate"
          @click="submitCreate"
        >
          <v-icon start> mdi-content-save </v-icon>

          Simpan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/utils/api";
import store from "@/store";

export default {
  name: "DialogCoa",

  data() {
    return {
      // MASTER
      listPart: ["PENJUALAN", "UMUM"],

      // FORM
      id: null,
      account: null,
      part: "PENJUALAN",
      name: null,

      // UI
      isDialogOpenCreate: false,
      isFormValidCreate: false,
      isLoadingSubmit: false,

      // VALIDATION
      rules: {
        required: [(v) => !!v || "Field wajib diisi"],

        requiredNumber: [
          (v) =>
            v !== null && v !== "" && v !== undefined
              ? true
              : "Field wajib diisi",
        ],
      },
    };
  },

  methods: {
    // =========================
    // OPEN DIALOG
    // =========================
    openDialogCreate(payload = {}) {
      this.resetForm();
      this.id = payload.id || null;
      this.account = payload.account || null;
      this.part = payload.part || null;
      this.name = payload.searchWorksheetBudget || null;
      this.isDialogOpenCreate = true;
    },

    // =========================
    // RESET FORM
    // =========================
    resetForm() {
      this.id = null;
      this.account = null;
      this.part = null;
      this.name = null;
      this.isFormValidCreate = false;

      this.$nextTick(() => {
        if (this.$refs.formCreate) {
          this.$refs.formCreate.resetValidation();
        }
      });
    },

    // =========================
    // SUBMIT CREATE
    // =========================
    async submitCreate() {
      const isValid = this.$refs.formCreate.validate();

      if (!isValid) return;

      this.isLoadingSubmit = true;

      store.dispatch("showLoading");

      try {
        const payload = {
          account: this.account,
          part: this.part,
          name: this.name,
        };

        const response = await api.post("/wb", payload);

        const message = response.data.message || "Berhasil menambahkan data";

        // emit ke parent
        this.$emit("success", response.data);

        // close dialog
        this.isDialogOpenCreate = false;

        // reset form
        this.resetForm();

        // snackbar
        store.dispatch("triggerSnackbar", {
          message,
          isSuccess: true,
        });
      } catch (error) {
        let message = "Gagal menambahkan data!";

        if (error.response) {
          message = error.response.data.message || message;
        } else {
          message = error.message || message;
        }

        store.dispatch("triggerSnackbar", {
          message,
          isSuccess: false,
        });
      } finally {
        this.isLoadingSubmit = false;

        store.dispatch("hideLoading");
      }
    },
  },
};
</script>
